/** A way to identify an entity */
export abstract class EntityIdentifier {
  /** Convert this identifer to json */
  abstract toJson(): any;

  /** Assign this identifer from json, @throws if it is invalid */
  abstract fromJson(json: any): void;
}

/** A way to indentify an entity via a string */
export class StringEntityIdenifier extends EntityIdentifier {
  public id: string;

  toJson() {
    return { id: this.id };
  }

  fromJson(json: any) {
    if (!angular.isString(json.id)) {
      throw new Error("invalid string entity idenifier");
    }
    this.id = json.id;
  }
}

/** A way to identify an entity via multiple ordered strings */
export class StringArrayEntityIdentifer extends EntityIdentifier {
  public ids: string[];

  toJson() {
    return { ids: this.ids };
  }

  fromJson(json: any) {
    if (!angular.isArray(json.ids)) {
      throw new Error("invalid string array entity idenifier");
    }
    this.ids = json.ids;
  }
}
